// @flow
import client from '../../client'

// Types
import type { PaypalAccount } from './register'

// API Endpoints
export const PAYPAL_ACCOUNTS_ENDPOINT = '/travel_agent/paypal_account/'

/**
 * Returns a new paypal account
 * @param {Object} data Paypal account information
 * @param {string} data.paypal_email Paypal email
 * @return {Promise|Error} A resolved Promise with the paypal account created or Rejected with an Error
 */
export const addPaypalAccount = (data: {
  paypal_email: string,
}): Promise<PaypalAccount> =>
  client.post(PAYPAL_ACCOUNTS_ENDPOINT, { body: data })

export default addPaypalAccount
